module.exports = __webpack_public_path__ + "static/img/iconmenu08.a185f1f3.svg";